import { Box, BoxProps, Typography, TypographyProps, alpha } from "@mui/material";
import React from "react";

export type ErrorBoxProps = {
    error: string | null | undefined;
    textProps?: TypographyProps;
} & BoxProps;

const ErrorBox = ({ error, textProps, ...props }: ErrorBoxProps) => {
    if (!error) return <React.Fragment />;
    return <Box width={1} py={1} borderRadius={1}  {...props} sx={{ bgcolor: theme => alpha(theme.palette.error.main, 0.9), ...props.sx }}>
        <Typography
            variant="body2"
            color="error.contrastText"
            textAlign="center"
            {...textProps}
            sx={{
                px: 1,
                ...textProps?.sx,
            }}
        >
            {error}
        </Typography>
    </Box>
}

export default ErrorBox;